import { RangeFilter } from '@flight-results/entities/request-search.payload';
import { CheckboxFilter, FilterSorterCriterias, PriceRangeFilter } from '@shared/filters/entities/fetch-filters.response';
import { RangeFilterPayload } from '@shared/filters/entities/range-filter';

export enum HotelFilterTypes {
  Category = 'Category',
  Zones = 'Zones',
  Ammenities = 'Ammenities',
  HotelPriceRanges = 'HotelPriceRanges',
  NonRefundable = 'NonRefundable',
  MinPrice = 'MinPrice',
  MaxPrice = 'MaxPrice',
  Results = 'Results',
  Price = 'Price',
  Categories = 'Categories',
  RefundableType = 'RefundableType',
  NextPage = 'NextPage',
  HotelName = 'HotelName',
  HotelNames = 'HotelNames',
  Tags = 'Tags',
  Boards = 'Boards',
  PromotionalRates = 'PromotionalRates',
  MemberRatesOnly = 'MemberRatesOnly',
  PackHours = 'PackHours',
  Sorters = 'Sorters',
  CheckinTimes = 'CheckinTimes',
  Score = 'Score'
}

export enum HotelFilterInputTypes {
  Checkbox = 'checkbox',
  Range = 'range',
  Radio = 'radio',
  Stars = 'Stars',
  Input = 'input'
}

export enum NonRefundableTypes {
  Refundable = 'Refundable',
  NonRefundable = 'NonRefundable'
}

export type HotelFilterApplierValue =
  string | string[] | number | number[] | RangeFilter | FilterSorterCriterias |
  RangeFilter[] | CheckboxFilter[] | PriceRangeFilter[] | RangeFilterPayload | boolean;

export type HotelFilterApplier = Readonly<{
  type: HotelFilterTypes,
  value?: HotelFilterApplierValue,
  removable?: boolean;
  clear?: boolean;
  widget?: Readonly<{ index?: number; }>;
}>;

export enum HotelFilterProvider {
  HotelResults = 'HOTELRESULTS',
  HotelMap = 'HOTELMAP'
}
